/* eslint-disable react/prop-types */
import React, { Suspense } from 'react';
import * as ERV_API from '../services/ervSalesGate';
import { SettingActionType } from '../state/action-types/settingTypes';
import store from '../state/store';

const DEFAULT_SID = '11111111-1111-1111-1111-111111111111';
const sessionId = store.getState().settingsReducer.sessionId || DEFAULT_SID;
const currentSteps = store.getState().settingsReducer.currentSteps;
const environment = store.getState().settingsReducer.environment;
const errorInfoConfig = store.getState().configReducer.components.ErrorInfo;

export default class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError = (error) => {
    return { hasError: true };
  };
  componentDidCatch(error, errorInfo) {
    ERV_API.logError(error.message, error);
    this.setState({ hasError: true });
    store.dispatch({ type: SettingActionType.SET_CURRENT_STEPS, payload: [...currentSteps, 1000] });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      const Element = React.lazy(() =>
        import(`../../src/components/${errorInfoConfig.properties.name}`),
      );
      return (
        <Suspense
          fallback={
            <div>
              <p>Lädt ...</p>
            </div>
          }>
          <Element properties={errorInfoConfig.properties} />
        </Suspense>
      );
    } else {
      return <>{children}</>;
    }
  }
}
